
import React, { useState, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Tile } from 'carbon-components-react';
import Button from 'carbon-components-react/lib/components/Button';
import Dropdown from 'carbon-components-react/lib/components/Dropdown';
import Fluid from 'carbon-components-react/lib/components/TextInput';
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants';
import axios from "axios";
import { FileUploader } from 'carbon-components-react';
import callPostApi from "../../requests/PostRequests";
import callGetApi from 'requests/GetRequests';
import { NaturePeopleOutlined } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';


require("./_quality-check.scss");



const UploadFilePage = props => {
    var rowsArray = [];
    var rowsClient = [];
    var rowsTech = [];
    const history = useHistory();
    const [loader, setLoader] = useState(false);
    const [RowsActual, setRowsActual] = useState([{}]);
    const [RowsClient, setRowsClient] = useState([{}]);
    const [RowsTech, setRowsTech] = useState([{}]);
    useEffect(() => {

        callGetApi(Constants.CODEQUALITYCHECKFRANCHISE,
            { 'Content-Type': 'application/json' },
            {}
        )
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element.acct_typ_nm;
                    rowsArray.push(taskobject);

                })
                setRowsActual(rowsArray);

            })
            .catch(err => {
                // if (err.response.status == 401) {
                //   localStorage.removeItem("token");
                //   localStorage.removeItem("expires_in");
                //   localStorage.removeItem("username");
                //   localStorage.removeItem("refresh_token");

                //   window.location.href = "/";
                // }
                //toast.error(uploadError);
            });
        callGetApi(Constants.CODEQUALITYCHECKTECHNOLOGY,
            { 'Content-Type': 'application/json' },

        )
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element.tclgy_nm;
                    rowsTech.push(taskobject);

                })
                setRowsTech(rowsTech);

            })
            .catch(err => {
                // if (err.response.status == 401) {
                //   localStorage.removeItem("token");
                //   localStorage.removeItem("expires_in");
                //   localStorage.removeItem("username");
                //   localStorage.removeItem("refresh_token");

                //   window.location.href = "/";
                // }
                //toast.error(uploadError);
            });
        callGetApi(Constants.CODEQUALITYCHECKCLIENT,
            { 'Content-Type': 'application/json' },
            {}
        )
            .then(res => {
                res.forEach(function (element) {
                    let taskobject = {};
                    taskobject['key'] = element.party_nm;
                    rowsClient.push(taskobject);

                })
                setRowsClient(rowsClient);

            })
            .catch(err => {

                //toast.error(uploadError);
            });




    }, []);
    const franchise = i18n.t('qualityCode.franchise');
    const technology = i18n.t('qualityCode.technology');
    const client = i18n.t('qualityCode.client');
    const project = i18n.t('qualityCode.project');
    const version = i18n.t('qualityCode.version');
    const home = i18n.t('qualityCode.Home');
    const qualityCheck = i18n.t('qualityCode.qualityCheck');
    const uploadFile = i18n.t('qualityCode.uploadfile');
    const fileDiscrption = i18n.t('qualityCode.fileDiscrption');
    const chooseFile = i18n.t('qualityCode.chooseFile');
    const code = i18n.t('qualityCode.code');
    const Addfiles = i18n.t('IncidentDetails.Addfiles');
    const edit = i18n.t('IncidentDetails.edit');
    const Clearfile = i18n.t('IncidentDetails.Clearfile')
    const Submit = i18n.t('qualityCode.submit')



    const [attachmentRequest, setAttachmentRequest] = useState({
        loadingAttachment: false,
        attachment: null,
    });


    const [projectname, setprojectname] = useState('');
    const [versionnumber, setversionnumber] = useState('');
    const [client1, setclient1] = useState('');
    const [technology1, settechnology1] = useState('');
    const [franchise1, setfranchise] = useState('');
    const [selectedFile, setselectedFile] = useState('');
    const [selectedSubmit, setselecteSubmit] = useState(true);
    const [upload_state, setuploadstate] = useState('');
    const [workNotesRequest, setWorkNotesRequest] = useState({
        upload_state: false,
        loaded: 0,
    });
    const [message, setselectedmessage] = useState('');
    const handleChangeSubmit = async (e) => {

        await uploadfile();

        //history.push("/uploadCompleted");
        //  props.history.push({ 
        //   pathname: '/uploadCompleted',
        //   state: message
        //  });
    }

    const handleChangefranchise = (e) => {
        //console.log("test...", e.selectedItem.key);
        setfranchise(e.selectedItem.key)
        validateForm();
    }

    const handleChangeClient = (e) => {
        //console.log("test...", e.selectedItem.key);
        setclient1(e.selectedItem.key)
        validateForm();
    }
    const handleChangeTech = (e) => {
        //console.log("test...", e.selectedItem.key);
        settechnology1(e.selectedItem.key)
        validateForm();
    }

    var files;

    const handleFileChanged = (e) => {
        files = e.target.files;

        setselectedFile(e.target.files);
        validateForm();
    }
    const handleProjectValue = (e) => {

        //console.log("value...", e.target.value)
        setprojectname(e.target.value);
        validateForm();
    }
    const handleVersionValue = (e) => {

        //console.log("value...", e.target.value)
        setversionnumber(e.target.value);
        validateForm();
    }
    const validateForm = (e) => {
        //console.log("Inside validateForm..." , projectname, versionnumber,client1,technology1);
        if (
            projectname &&
            versionnumber &&
            client1 &&
            franchise1 &&
            selectedFile) {
            //console.log("Inside validateForm...");
            setselecteSubmit(false)
        } else if (
            files &&
            projectname &&
            client1 &&
            franchise1 &&
            technology1
        ) {
            //console.log("Inside validateForm...");
            setselecteSubmit(false)
        } else {
            //console.log("Inside validateForm...");
            setselecteSubmit(true)
        }

    }




    const uploadfile = async () => {
        //console.log("Inside uploadfile...");
        if (
            projectname === "" ||
            versionnumber === "" ||
            client1 === "" ||
            technology1 === "" ||
            selectedFile.length === 0
        ) {
            alert("All the fields are mandatory");
        } else {

            setuploadstate(true)

            const data = new FormData();

            for (var x = 0; x < selectedFile.length; x++) {
                data.append("file", selectedFile[x]);
                data.append("file_type", selectedFile[x].type);
            }

            data.append("businessParty", client1);

            data.append("technology", technology1);
            data.append("franchise", franchise1);

            data.append("partyowningcode", 11);
            data.append("versionnumber", versionnumber);
            data.append("projectname", projectname);
            data.append("datetime", Date.now());
            data.append("status", true);
            data.append("username", JSON.parse(localStorage.getItem('user')).username);

            for (var value of data.values()) {
                //console.log(value);
            }
            //console.log(data.get("datetime"));

            callPostApi(Constants.CODEQUALITYCHECKUPLOADFILE, { 'Content-Type': 'application/json' }, data,
                {
                    onUploadProgress: ProgressEvent => {
                        setWorkNotesRequest({
                            upload_state: true,
                            loaded: (ProgressEvent.loaded / ProgressEvent.total) * 100
                        });
                    }

                }
            )
                .then(res => {
                    //console.log("--------------",res.message);
                    setselectedmessage(res.message)
                    history.push({
                        pathname: '/qualityCheck/uploadFile_status',
                        request_no: res.message
                    });
                    setLoader(true)
                    //console.log(JSON.stringify(res.status));
                    if (res.status == 200) {
                        // this.setState({
                        //   open: false,
                        //   upload_state: false,
                        //   businessParty: "",
                        //   businessParty1: "",
                        //   technology1: "",
                        //   client1: "",
                        //   versionnumber: "",
                        //   projectname: ""
                        // });
                        // props.handleStatus(res.status);
                    }
                })
                .catch(err => {
                    if (err.response.status == 401) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("expires_in");
                        localStorage.removeItem("username");
                        localStorage.removeItem("refresh_token");

                        window.location.href = "/";
                    }
                    //toast.error(uploadError);
                });
        }
    };



    return (
        <div className="quality-check-wrapper">
            <div className="quality-check-container">
                <div className="quality-check-header">
                    <div>
                        <Breadcrumb noTrailingSlash aria-label="Page navigation">
                            <BreadcrumbItem href='/homepage'>
                                {home}
                            </BreadcrumbItem>
                            <BreadcrumbItem href='/qualityCheck'>
                                {qualityCheck}
                            </BreadcrumbItem>
                        </Breadcrumb>
                        <div className="title">
                            {code}
                        </div>
                    </div>
                    <div>
                        <Button className="upload-bx--btn" onClick={handleChangeSubmit} disabled={selectedSubmit}>{Submit}</Button>
                    </div>
                </div>
            </div>
            <Tile>
                <div className="page-margin">
                    <div className="qualityMargin">
                        {uploadFile}
                    </div>
                    <div className="incident-no-upload">
                        <ul className="vertical-line-no-upload">
                            <div className="qualityMargin">
                                {fileDiscrption}
                            </div>

                        </ul>
                        <ul>
                            {/* <Button className="margin-left-10px" kind="secondary" >{chooseFile}</Button> */}
                            <FileUploader
                                accept={['.bprelease', '.xaml', '.atmx']}
                                buttonKind="secondary"
                                buttonLabel={chooseFile}
                                filenameStatus={edit}
                                iconDescription={Clearfile}
                                labelDescription=""
                                labelTitle=""
                                className="upload-bx--btn"
                                onChange={e => handleFileChanged(e)}
                            //key={this.state.fileInputKey}
                            />
                        </ul>
                    </div>
                </div>
                <hr className="line-shadow" />
                <div>
                    <ul className="incidentQualityCheck">

                        <li>
                            <Fluid labelText={project} onChange={e => handleProjectValue(e)} />
                        </li>

                        <li>
                            <Fluid labelText={version} onChange={e => handleVersionValue(e)} />

                        </li>
                    </ul>
                    <ul className="incidentQualityCheck">
                        <li>
                            <Dropdown
                                id="qualitycode"
                                titleText={client}
                                helperText=""
                                label={""}
                                items={RowsClient}
                                itemToString={(item) => (item ? item.key : null)}
                                onChange={handleChangeClient}
                            />

                        </li>
                        <li>
                            <Dropdown
                                id="qualitycode"
                                titleText={franchise}
                                helperText=""
                                label={""}
                                items={RowsActual}
                                itemToString={(item) => (item ? item.key : null)}
                                onChange={handleChangefranchise}
                            />

                        </li>
                        <li>
                            <Dropdown
                                id="qualitycode"
                                titleText={technology}
                                helperText=""
                                label={""}
                                items={RowsTech}
                                //selectedItem={this.state.incidentArray.subcategory}
                                itemToString={(item) => (item ? item.key : null)}
                                onChange={handleChangeTech}
                            />

                        </li>

                    </ul>
                </div>
            </Tile>
        </div>
    );
};

export default UploadFilePage;

